export default [
    {
        path: 'Fwamework/AdministrationSummary',
        name: 'AdministrationSummary'
    }
];